interface AdminUserCellProps {
  name?: string | null;
  userId?: string | null;
}

export default function AdminUserCell({ name, userId }: AdminUserCellProps) {
  const displayName = name?.trim() || userId?.trim() || "-";
  const account = userId?.trim();
  const showAccount = account && account !== displayName;

  return (
    <div>
      <div className="text-sm font-medium text-gray-800 leading-snug whitespace-nowrap mb-1">
        {displayName}
      </div>
      {showAccount && <div className="text-[11px] text-gray-400 whitespace-nowrap">{account}</div>}
    </div>
  );
}
